import React from 'react';
import { JdsD92ReportIcon as JdsD92Icon } from '@/assets/icons/JdsD92ReportIcon';
import { JdsD86ReportIcon as JdsD86Icon } from '@/assets/icons/JdsD86ReportIcon';
import Icon, { FileTextOutlined, FileAddOutlined, ExceptionOutlined } from '@ant-design/icons';
import {
	REPORT_NAME_KEYS,
	REPORT_NAMES_MAP,
	REPORT_TYPES,
	REPORT_ACRONYMS,
	ICON_REPORT_RADIO_STYLE
} from '@/utils/constants';

interface CustomReportIcon {
	icon: JSX.Element;
	acronym: string;
	name: string;
	label: string;
	report_type: string;
}

export const customReportIconList: CustomReportIcon[] = [
	{
		name: REPORT_NAME_KEYS.BERA,
		acronym: REPORT_ACRONYMS.BERA,
		label: REPORT_NAMES_MAP[REPORT_NAME_KEYS.BERA],
		report_type: REPORT_TYPES.BERA,
		icon: <FileAddOutlined style={ICON_REPORT_RADIO_STYLE} />
	},
	{
		name: REPORT_NAME_KEYS.SERA,
		acronym: REPORT_ACRONYMS.SERA,
		label: REPORT_NAMES_MAP[REPORT_NAME_KEYS.SERA],
		report_type: REPORT_TYPES.SERA,
		icon: <ExceptionOutlined style={ICON_REPORT_RADIO_STYLE} />
	},
	{
		name: REPORT_NAME_KEYS.JDS_D86,
		acronym: REPORT_ACRONYMS.JDS_D86,
		label: REPORT_NAMES_MAP[REPORT_NAME_KEYS.JDS_D86],
		report_type: REPORT_TYPES.CUSTOM,
		icon: <Icon style={ICON_REPORT_RADIO_STYLE} component={JdsD86Icon} />
	},
	{
		name: REPORT_NAME_KEYS.JDS_D92,
		acronym: REPORT_ACRONYMS.JDS_D92,
		label: REPORT_NAMES_MAP[REPORT_NAME_KEYS.JDS_D92],
		report_type: REPORT_TYPES.CUSTOM,
		icon: <Icon style={ICON_REPORT_RADIO_STYLE} component={JdsD92Icon as React.FC} />
	},
	{
		name: REPORT_NAME_KEYS.EWA,
		acronym: REPORT_ACRONYMS.EWA,
		label: REPORT_NAMES_MAP[REPORT_NAME_KEYS.EWA],
		report_type: REPORT_TYPES.CUSTOM,
		icon: <FileTextOutlined style={ICON_REPORT_RADIO_STYLE} />
	},
	{
		name: REPORT_NAME_KEYS.EWA_D86,
		acronym: REPORT_ACRONYMS.EWA_D86,
		label: REPORT_NAMES_MAP[REPORT_NAME_KEYS.EWA_D86],
		report_type: REPORT_TYPES.CUSTOM,
		icon: <FileTextOutlined style={ICON_REPORT_RADIO_STYLE} />
	}
];
